<script setup lang="ts">
import type { TNewsSidebarItem } from '~/components/entity/news/sidebar-item/types'

const props = defineProps<TNewsSidebarItem>()

const formattedDate = computed(() =>
  props.publication_datetime ? useDateTimeFormat(props.publication_datetime) : ''
)
</script>

<template>
  <article class="SidebarItem">
    <NuxtLinkLocale :to="props.url" class="after:absolute after:inset-0 hover:underline"
      >{{ props.title }}
    </NuxtLinkLocale>
    <span v-if="formattedDate" class="text-xs text-gray-500">{{ formattedDate }}</span>
  </article>
</template>
